import { ReactElement } from 'react'
import {
  Loader,
  SectionTitle,
  StudentTestCard,
  TostMessage
} from '../../../../components'
import strings from '../../../../locale/en'
import { TestType } from '../../../../const/type'
import { TestWrapper, TestListWrapper } from '../subcomponents'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { answeredTestPaper, updateError } from '../../../../redux/test/action'
import { AttemptedTestsProps } from '../typings'

const AttemptedTests = ({
  attemptedTests, 
}: AttemptedTestsProps): ReactElement => {
  const {
    isLoading,
    studentId = '',
    error
  } = useSelector(
    (state: RootState) => ({
      isLoading: state.test.isAttemptedTestsLoading,
      studentId: state.user?.userInfo?.userDetail?.usersId,
      error: state.test.error
    }),
    shallowEqual
  )
  const dispatch = useDispatch() 
  console.log(attemptedTests);

  return (
    <TestWrapper>
      {error && (
        <TostMessage
          show={!!error}
          onCloseHandler={() => dispatch(updateError(''))}
          message={error}
        />
      )}
      <SectionTitle title={strings.assessment.attemptedTests} />
      <TestListWrapper>
        {isLoading ? (
          <Loader />
        ) : (
          attemptedTests?.map((test, index) => {
            const { name, duration, questionCount, publishDateTime } = test
            console.log('efef',name);

            return (
              <StudentTestCard
                testType={TestType.ATTEMPTED}
                name={name}
                duration={duration}
                publishDateTime={publishDateTime}
                questionCount={questionCount}
                key={`scheduled-test-${index}`}
                onSelect={() =>
                  dispatch(
                    answeredTestPaper({
                      studentId,
                      testPaperId: test?.testPaperId
                    })
                  )
                }
                status={strings.test.result}
              />
            )
          })
        )} 
      </TestListWrapper>
    </TestWrapper>
  )
}

export default AttemptedTests
